module.exports = __webpack_public_path__ + "assets/font/FZYanSJW-d24e6d13.TTF";